import apiFetch from '../../apiFetch'

export default function (idTipoAlimentacion, token) {
  return apiFetch({endPoint: `TipoAlimentacion/deleteTipoAlimentacion?idTipoAlimentacion=` + idTipoAlimentacion, method: 'GET', body: null, token: token})
}